var path = 'src/app/patients/addresses/addresses.html';
var html = "<h1 class=page-header>Addresses</h1> <div patient-addresses-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/addresses/addresses.html
 ** module id = 383
 ** module chunks = 0
 **/